import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'GenerationResult' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        gap: 12
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 8,
        borderRadius: 8,
        background: '#F8F8F8'
    },
    text: {
        margin: 0,
        padding: 0,
        color: '#232323',
        fontSize: 20,
        fontWeight: 700,
        lineHeight: '150%'
    },
    markdown: {
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        letterSpacing: '-0.28px',
        ['*:first-child']: {
            marginTop: 0
        },
        ['*:last-child']: {
            marginBottom: 0
        }
    }
});
